module.exports = __webpack_public_path__ + "media/images/iconbox/icon6-17764deee7c3d982de1f2271f03f2078.png";